import { Injectable, OnInit, Input, Inject, Directive } from '@angular/core';
import { Employee, ReportGenSvc } from 'src/app/services_autogenerated/generated_services';

@Directive()
@Injectable()
export abstract class BaseReportCardComponent {
    @Input() employee: Employee;
    @Input() title: string;
    @Input() companyWide: boolean;
    startDate: Date;
    endDate: Date;
}